import Commonbadge from "../../../Components/Common/Commonbadge";

export const IconBook = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
    </svg>
);



export const IconCheck = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);

export const IconUser = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
    </svg>
);





export const getSummaryTableColumns = (navigate: any) => [
    {
        key: "studycode",
        label: "Study Code",
        cell: (row: any) => (
            <span
                style={{ color: "#2563eb", cursor: "pointer", fontWeight: 600 }}
                onClick={() => navigate(`/study/detail/${row.studyid}`)}
            >
                {row.studycode}
            </span>
        ),
    },
    {
        key: "studytitle",
        label: "Study Title",
        tooltip: true,
        maxLength: 40,
    },
    {
        key: "sponsorname",
        label: "Sponsor",
        tooltip: true,
        maxLength: 40,
    },
    {
        key: "numberofperiods",
        label: "Periods",
        textCenter: true,
        cell: (row: any) => <span>{row.numberofperiods || "—"}</span>,
    },
    {
        key: "studydesigntext",
        label: "Study Design",
        tooltip: true,
        maxLength: 40,
    },
    {
        key: "studystatus",
        label: "Status",
        textCenter: true,
        cell: (row: any) => (
            row.studystatus
                ? <Commonbadge status={row.studystatus} />
                : <span>—</span>
        ),
    },
];


export const IconThreePeople = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const IconUsers = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const IconCheckSquare = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 11 12 14 22 4"></polyline>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
  </svg>
);

export const IconUserCheck = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="8.5" cy="7" r="4"></circle>
    <polyline points="17 11 19 13 23 9"></polyline>
  </svg>
);

export const IconRibbon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  </svg>
);

export const IconExclamation = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

export const IconFlask = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2h12"></path>
    <path d="M10 2v7.5a2.5 2.5 0 0 0 5 0V2"></path>
    <path d="M8.5 2h7c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 7 18.5V3.5C7 2.7 7.7 2 8.5 2z"></path>
    <path d="M8.5 22h7a4.5 4.5 0 0 0 0-9H8.5a4.5 4.5 0 0 0 0 9Z"></path>
  </svg>
);

export const IconTag = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <line x1="7" y1="7" x2="7.01" y2="7"></line>
  </svg>
);

export const IconUserPlus = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="8.5" cy="7" r="4"></circle>
    <line x1="20" y1="8" x2="20" y2="14"></line>
    <line x1="23" y1="11" x2="17" y2="11"></line>
  </svg>
);

export const IconDoorOpen = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
    <polyline points="10 17 15 12 10 7"></polyline>
    <line x1="15" y1="12" x2="3" y2="12"></line>
  </svg>
);

export const IconSyringe = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="2" x2="22" y2="6"></line>
    <line x1="7.5" y1="12.5" x2="11.5" y2="16.5"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
    <line x1="17" y1="3" x2="11" y2="9"></line>
    <path d="m5 16-3 3v2h2l3-3"></path>
    <path d="M14 6l4 4"></path>
  </svg>
);

export const IconUsersCheck = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="m16 11 2 2 4-4"></path>
  </svg>
);

export const IconBuilding = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
    <line x1="9" y1="22" x2="9" y2="16"></line>
    <line x1="15" y1="22" x2="15" y2="16"></line>
    <line x1="9" y1="16" x2="15" y2="16"></line>
    <path d="M8 6h2v2H8V6z"></path>
    <path d="M14 6h2v2h-2V6z"></path>
    <path d="M8 10h2v2H8v-2z"></path>
    <path d="M14 10h2v2h-2v-2z"></path>
  </svg>
);

export const IconCalendar = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

export const IconBell = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
);


  export const renderSkeleton = (styles:any,skeletonStyles:any) => (
    <>
      {/* Top Row Grid Skeleton */}
      <div className={styles.topRowGrid}>
        {/* Left Study Profile Card Skeleton */}
        <div className={styles.studyProfileCard}>
          <div className={styles.leftSection} style={{ width: "45%" }}>
            <div className={`${skeletonStyles.skeleton} ${skeletonStyles.skeletonIcon}`} style={{ width: "2.5rem", height: "2.5rem" }} />
            <div className={styles.studyIdentity} style={{ width: "100%" }}>
              <div className={skeletonStyles.skeleton} style={{ height: "10px", width: "60px", marginBottom: "6px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "24px", width: "120px", marginBottom: "8px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "90%" }} />
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.rightSection} style={{ width: "50%" }}>
            <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "100%", marginBottom: "8px" }} />
            <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "90%", marginBottom: "8px" }} />
            <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "95%", marginBottom: "8px" }} />
            <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "85%" }} />
          </div>
        </div>

        {/* Right 5 Stats Cards Grid Skeleton */}
        <div className={styles.statsSubGrid}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div className={styles.statItemCard} key={i}>
              <div className={styles.cardTop}>
                <div className={`${skeletonStyles.skeleton} ${skeletonStyles.skeletonIcon}`} style={{ width: "1.75rem", height: "1.75rem" }} />
                <div className={skeletonStyles.skeleton} style={{ height: "20px", width: "40px" }} />
              </div>
              <div className={styles.cardBottom}>
                <div className={skeletonStyles.skeleton} style={{ height: "10px", width: "65px", marginBottom: "4px" }} />
                <div className={skeletonStyles.skeleton} style={{ height: "8px", width: "40px" }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Middle Grid Quick Actions Skeleton */}
      <div className={styles.middleGrid} style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "0.875rem", marginBottom: "1.25rem" }}>
        {Array.from({ length: 7 }).map((_, i) => (
          <div className={styles.quickActionCard} key={i} style={{ padding: "0.875rem" }}>
            <div className={`${skeletonStyles.skeleton} ${skeletonStyles.skeletonIcon}`} style={{ width: "1.75rem", height: "1.75rem", marginBottom: "10px" }} />
            <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "60px", marginBottom: "6px" }} />
            <div className={skeletonStyles.skeleton} style={{ height: "8px", width: "40px" }} />
          </div>
        ))}
      </div>

      {/* Bottom Layout Grid Skeleton (3 columns: 4.2fr 3.6fr 4.2fr) */}
      <div className={styles.dashboardGrid}>
        {/* Column 1: Subject Status Overview Skeleton */}
        <div className={styles.premiumCard}>
          <div className={styles.cardHeader}>
            <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "160px" }} />
          </div>
          <div className={styles.cardBody} style={{ minHeight: "220px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <div className={skeletonStyles.skeleton} style={{ height: "110px", width: "110px", borderRadius: "50%", marginBottom: "12px" }} />
            <div style={{ width: "100%" }}>
              <div className={skeletonStyles.skeleton} style={{ height: "10px", width: "100%", marginBottom: "6px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "10px", width: "95%", marginBottom: "6px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "10px", width: "90%" }} />
            </div>
          </div>
        </div>

        {/* Column 2: 2 Tables Skeletons */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
          {/* Table 1: Batch Status Skeleton */}
          <div className={styles.premiumCard}>
            <div className={styles.cardHeader}>
              <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "100px" }} />
            </div>
            <div className={styles.cardBody}>
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="d-flex justify-content-between mb-2">
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "70px" }} />
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "80px" }} />
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "40px" }} />
                </div>
              ))}
            </div>
          </div>

          {/* Table 2: Label Summary Skeleton */}
          <div className={styles.premiumCard}>
            <div className={styles.cardHeader}>
              <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "100px" }} />
            </div>
            <div className={styles.cardBody}>
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="d-flex justify-content-between mb-2">
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "60px" }} />
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "80px" }} />
                  <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "50px" }} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Column 3: Admissions, Dosing, Sponsor Skeletons */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
          {/* Item 1: Admission Progress */}
          <div className={styles.premiumCard}>
            <div className={styles.cardHeader}>
              <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "140px" }} />
            </div>
            <div className={styles.cardBody}>
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "100%", marginBottom: "8px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "95%" }} />
            </div>
          </div>

          {/* Item 2: Dosing Summary */}
          <div className={styles.premiumCard}>
            <div className={styles.cardHeader}>
              <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "120px" }} />
            </div>
            <div className={styles.cardBody}>
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "100%", marginBottom: "8px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "90%" }} />
            </div>
          </div>

          {/* Item 3: Sponsor Info */}
          <div className={styles.premiumCard}>
            <div className={styles.cardHeader}>
              <div className={skeletonStyles.skeleton} style={{ height: "14px", width: "140px" }} />
            </div>
            <div className={styles.cardBody}>
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "100%", marginBottom: "8px" }} />
              <div className={skeletonStyles.skeleton} style={{ height: "12px", width: "85%" }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );